import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-show-changes-column',
  template: `<button nbButton size="tiny" outline shape="round" [disabled]="disabled" (click)="onClick()">{{ buttonLabel }}</button>`,
  encapsulation: ViewEncapsulation.None,
})
export class ShowChangesColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public buttonLabel: string = "";
  public disabled: boolean = false;

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.buttonLabel = Objects.safeGetValue(this.params, 'buttonLabel', "");
    this.disabled = !this.params.data.isChanged;
  }

  ngOnInit() {
  }

  onClick() {
    this.params.context.showMore(this.params.data);
  }
  
}
